module.exports = __webpack_public_path__ + "img/vector.4e68042.svg";